import React, { memo, useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { message } from 'antd';

import '../../../node_modules/video-react/dist/video-react.css';
import { Player, ControlBar, BigPlayButton, Shortcut } from 'video-react';

import styles from './TopImgVideo.module.less';
import './animation.css';
import fail from '../../static/msg-fail.svg';
import { setTopImgVideoVisible } from '../../actions/layout';
import { useActivate, useUnactivate } from 'react-activation';

export default memo(({ page, data = {}, node, height = 220 }) => {
  const [player, setPlayer] = useState(null);
  const nodeRef = useRef(null);
  const dispatch = useDispatch();

  useActivate(() => {
    dispatch(
      setTopImgVideoVisible({ visible: node.scrollTop < height, isScrolled: false, data: null }),
    );
  });

  useEffect(() => {
    handleScroll()
    dispatch(setTopImgVideoVisible({ visible: true, isScrolled: false, data: null }));
    return () => {
      dispatch(setTopImgVideoVisible({ visible: false, isScrolled: false, data: null }));
    };
  }, []);

  useUnactivate(() => {
    dispatch(setTopImgVideoVisible({ visible: false, isScrolled: false, data: null }));
  });

  const handleScroll = function() {
    // 软件详情页面可能配置不显示
    if (page === 'detail' && data?.showVideo === '0') {
      dispatch(setTopImgVideoVisible({ visible: false, isScrolled: false, data: null }));
      return;
    }
    if (nodeRef && nodeRef.current && node) {
      nodeRef.current.style.position = 'relative';
      nodeRef.current.style.top = `-${node.scrollTop}px`;
      nodeRef.current.style.opacity =
        1 - (node.scrollTop / height > 0.9 ? 1 : node.scrollTop / height);
      dispatch(
        setTopImgVideoVisible({ visible: node.scrollTop < height, isScrolled: false, data: null }),
      );
    }
  };

  /**
   * 初始化、和每次检查更新组件关闭时对比当前是否是最新版本独立包
   * 更新是否需要展示小红点
   */
  useEffect(() => {
    window.TopVideoPlayPause = (isPlay, isMute) => {
      if (player.actions) {
        player.actions.togglePlay();
        player.actions.mute(isMute);
      }
    };
  }, [player]);

  useEffect(() => {
    if (player) {
      player.subscribeToStateChange(e => {
        const { error } = e;
        if (error === 'UNKNOWN ERROR') {
          message.error({
            content: '视频播放失败',
            icon: <img className="ant-message-custom-img" src={fail} alt="fail" />,
          });
        }
        // setPause(paused);
      });
    }
  }, [player]);

  useEffect(() => {
    if (node) {
      node.addEventListener('scroll', handleScroll);
    }
  }, [node]);

  if (page === 'detail') {
    return (
      <div className={styles.img_video_detail} ref={nodeRef}>
        {data.showVideo === '1' ? (
          <>
            <div className={styles.detail_video_bgbox}>
              <img className={styles.detail_video_bg} src={data.coverImg} />
            </div>
            <div className={styles.detail_video}>
              <Player
                src={`${data.videoUrl}`}
                poster={data.coverImg}
                ref={p => setPlayer(p)}
                className={styles.player}
                playsInline={true}
                fluid={false}
                autoPlay={true}
                muted={true}
                loop={true}
                width={`100%`}
                height={`100%`}
              >
                <Shortcut clickable={false} dblclickable={false} />
                <BigPlayButton position="center" className={styles.player_btn} />
                <ControlBar
                  disableCompletely={true}
                  disableDefaultControls={true}
                  className={styles.player_controlbar}
                />
              </Player>
            </div>
          </>
        ) : (
          <>
            <div className={styles.detail_video_bgbox}>
              <img className={styles.detail_video_bg} src={data.coverImg} />
            </div>
            <img className={styles.detail_img} src={data.coverImg} />
          </>
        )}
      </div>
    );
  }

  if (page === 'special') {
    return (
      <div className={styles.img_video_special} ref={nodeRef}>
        <div className={styles.img_video_special_bgbox}>
          <img src={data.img} className={styles.img_video_special_bg} />
        </div>
        <img src={data.img} className={styles.detail_img} />
      </div>
    );
  }
  return null;
});
